<template>
    <div class='container'>
        <div class='clause'>
            <h3 class='text text-center'>{{content.title}}</h3>
            <p>{{content.abstraction}}</p>
            <div class='clause-section' v-for='(clause, index) in content.protocols' :key='`clause-${index}`'>
                <h4 v-if='clause.name'>{{clause.name}}</h4>
                <div v-for='(item, index) in clause.list' :key='`item-${index}`'>
                    <p v-html='item.text'/>
                    <ol v-if='item.details'>
                        <li v-for='(detail, index) in item.details' :key='`detail-${index}`' class='text text-small'>
                            {{detail}}
                        </li>
                    </ol>
                </div>
            </div>
            <regulation-footer/>
        </div>
    </div>
</template>

<script>
    import { USER_AGREEMENT } from '@/clause/regulation/user.agreement'
    import { RESPONSIBILITY_STATEMENT } from '@/clause/regulation/platform.responsibility'
    import RegulationFooter from '@/components/footprint'

    export default {
        components: {
            RegulationFooter
        },
        data () {
            return {
                content: {},
                regulations: {
                    user: USER_AGREEMENT,
                    responsibility: RESPONSIBILITY_STATEMENT
                }
            }
        },
        created () {
            this.content = this.regulations[this.$route.params.name]
        }
    }
</script>
